module.exports = __webpack_public_path__ + "static/media/BG-contract-MRH.923d925e.svg";